
  export default {
    name: 'CurrentTime',
    data() {
      return {
        timezone: 'UTC+07:00',
        timeInterval: null,
        time: '-',
        date: '-'
      }
    },
    created() {
      const tz = this.$dayjs()
      this.time = tz.format('HH:mm:ss')
      this.date = tz.format('DD-MM-YYYY')
    },
    mounted() {
      this.startTimeUpdate()
    },
    beforeDestroy() {
      if (this.timeInterval) {
        clearInterval(this.timeInterval)
      }
    },
    methods: {
      startTimeUpdate() {
        const now = this.$dayjs()
        const msUntilNextSecond = 1000 - now.millisecond()

        setTimeout(() => {
          this.updateTime()
          this.timeInterval = setInterval(() => this.updateTime(), 1000)
        }, msUntilNextSecond)
      },
      updateTime() {
        const tz = this.$dayjs()
        this.time = tz.format('HH:mm:ss')
        this.date = tz.format('DD-MM-YYYY')
      }
    }
  }
